var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconPlaylist = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeWidth: "2.167", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-2.167 -5.417)" },
                React.createElement("path", { d: "M10.7,10.8h14.1" }),
                React.createElement("path", { d: "M10.7,23.8h6" }),
                React.createElement("path", { d: "M5.3,10.8L5.3,10.8" }),
                React.createElement("path", { d: "M5.3,17.3L5.3,17.3" }),
                React.createElement("path", { d: "M5.3,23.8L5.3,23.8" }),
                React.createElement("path", { d: "M10.7,17.3h14.1" })),
            React.createElement("g", { transform: "translate(7.798 -8.417)" },
                React.createElement("path", { d: "M19.1,29.8l-6.5,4.5v-8.9L19.1,29.8z" })))));
});
export default IconPlaylist;
//# sourceMappingURL=IconPlaylist.js.map